/** Human-readable labels for mission / task `entity_type` API values. */
import type { BadgeColor } from "@/components/ui/badge/Badge";

export type MissionRowBadgeColor = BadgeColor;

export const ENTITY_TYPE_DISPLAY: Record<string, string> = {
  fa_client: "Client",
  compliance_case: "Case",
  // Future types (per schema design):
  client: "Client",
  portfolio: "Portfolio",
  fund: "Fund",
  policy: "Policy",
};

export const ENTITY_TYPE_BADGE_COLOR: Record<string, MissionRowBadgeColor> = {
  fa_client: "blue",
  compliance_case: "amber",
  client: "blue",
  portfolio: "sky",
  fund: "emerald",
  policy: "violet",
};

export function formatEntityTypeLabel(
  entityType: string | null | undefined
): string {
  if (!entityType) return "";
  return ENTITY_TYPE_DISPLAY[entityType] ?? entityType;
}

export function getEntityTypeBadgeColor(
  entityType: string | null | undefined
): MissionRowBadgeColor {
  if (!entityType) return "zinc";
  return ENTITY_TYPE_BADGE_COLOR[entityType] ?? "zinc";
}
